import { render, staticRenderFns } from "./StoryReaction.vue?vue&type=template&id=eff3fe7a&"
import script from "./StoryReaction.vue?vue&type=script&lang=ts&"
export * from "./StoryReaction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports